/**
 * Tier visual helpers — admin portal pills, dashboard donut.
 *
 * Kept separate from lib/tier.js so admin styling can evolve independently
 * of the customer-facing tier copy.
 */

export const TIER_LABEL = {
  ospite: "Ospite",
  amico: "Amico",
  famiglia: "Famiglia",
  padrone: "Padrone",
};

/** Inline pill className per tier (Inter, tracked uppercase). */
export const tierPillClass = (tier) => {
  const base =
    "inline-flex items-center px-2.5 py-1 font-body font-semibold text-[10px] tracking-[0.22em] uppercase border";
  switch (tier) {
    case "padrone":
      return `${base} bg-napoli-gold/15 text-napoli-gold border-napoli-gold/50`;
    case "famiglia":
      return `${base} bg-napoli-oxblood text-napoli-cream border-napoli-oxblood`;
    case "amico":
      return `${base} bg-napoli-rose/40 text-napoli-oxblood-dark border-napoli-rose/60`;
    case "ospite":
    default:
      return `${base} bg-napoli-cream-warm text-napoli-espresso border-napoli-espresso-soft/40`;
  }
};

/** Donut slice colors per tier (recharts). */
export const TIER_COLOR = {
  ospite: "#EFE3CE", // cream-warm
  amico: "#D9A5A5", // rose
  famiglia: "#8B1E2C", // oxblood
  padrone: "#C5A04D", // gold
};

export const tierLabel = (t) => TIER_LABEL[t] || (t ? t.charAt(0).toUpperCase() + t.slice(1) : "—");
